import { render, staticRenderFns } from "./ItineraryDetail.vue?vue&type=template&id=5463b1fa&scoped=true&"
import script from "./ItineraryDetail.vue?vue&type=script&lang=js&"
export * from "./ItineraryDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryDetail.vue?vue&type=style&index=0&id=5463b1fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5463b1fa",
  null
  
)

export default component.exports